import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';
import { titleCase } from '../utils/format';

type BadgeStatus = string | null | undefined;

/**
 * Status colours follow docs/07: pending yellow, active green, suspended
 * orange, inactive grey, overdue red. The label is always shown so colour is
 * never the only signal.
 */
const STATUS_STYLES: Record<string, { color: ChipProps['color']; variant?: ChipProps['variant'] }> =
  {
    PENDING: { color: 'warning', variant: 'outlined' },
    ACTIVE: { color: 'success' },
    SUSPENDED: { color: 'warning' },
    INACTIVE: { color: 'default' },
    OVERDUE: { color: 'error' },
    DRAFT: { color: 'default', variant: 'outlined' },
    ISSUED: { color: 'info', variant: 'outlined' },
    PARTIALLY_PAID: { color: 'warning' },
    PAID: { color: 'success' },
    VOID: { color: 'default', variant: 'outlined' },
    CASH: { color: 'default', variant: 'outlined' },
    GCASH: { color: 'info', variant: 'outlined' },
    BANK_TRANSFER: { color: 'secondary', variant: 'outlined' },
    RESIDENTIAL: { color: 'default', variant: 'outlined' },
    BUSINESS: { color: 'secondary', variant: 'outlined' },
  };

interface StatusBadgeProps {
  status: BadgeStatus;
  size?: ChipProps['size'];
}

export function StatusBadge({ status, size = 'small' }: StatusBadgeProps) {
  if (!status) return <span>—</span>;

  const style = STATUS_STYLES[status] ?? { color: 'default' as const };
  return (
    <Chip
      label={titleCase(status)}
      color={style.color}
      variant={style.variant ?? 'filled'}
      size={size}
      sx={{ fontWeight: 600 }}
    />
  );
}
